export default __webpack_public_path__ + "static/media/sienas4-min.a7ad560a.jpg";